import { createFileRoute } from '@tanstack/react-router';

import { MessageCreatePage } from '@apps/web/components/surveys/survey_create_page';

export const Route = createFileRoute('/_app/(main)/outreaches/message/create')({
    head: () => ({
        meta: [
            {
                title: 'Create Message | Phoebe',
            },
        ],
    }),
    component: MessageCreatePage,
});
